import { NodeResizerProps } from '@xyflow/react';

import { COLORS } from '@/styles/tokens/colors';

// Shared NodeResizer styling for diagram nodes (tiles, relationship labels):
// a navy selection outline with small white square handles. TextNoteNode uses
// its own slightly lighter (NAVY[800]) variant.
export const NODE_RESIZER_LINE_STYLE: NodeResizerProps['lineStyle'] = {
  zIndex: 1,
  borderColor: COLORS.NAVY[900],
};

export const NODE_RESIZER_HANDLE_STYLE: NodeResizerProps['handleStyle'] = {
  zIndex: 1,
  backgroundColor: COLORS.PRIMITIVES.WHITE,
  height: 8,
  width: 8,
  outline: `1px solid ${COLORS.NAVY[900]}`,
};
